//------------------ PRODUCT DISCRIPION TAB ------------------//

// $(document).ready(function(){
//   $(".tabcontent").hide();
//   $(".tabcontent:eq(0)").show()

//   $('.tab-title').click(function(){
//     $(this).addClass('active-tab');
//     $(this).siblings().addClass('active');
//     $(this).parent().siblings().find('.tabcontent').removeClass('active');
//     $(this).parent().siblings().find('.tab-title').removeClass('active-tab');
//     $(".tabcontent").hide();
//     $(this).siblings(".tabcontent").show();
//   });
// });
setTimeout(function(){
$(".template-index .jsp-container .gm-menu .gm-item .gm-target .gm-text").css("color", "white !important");
  }, 5000);
setTimeout(function(){
$(".template-product .jj-pr-price .discountedpricepp.skiptranslate.notranslate.currency-converter-wrapper-amount-box").css("display", "none");

  }, 2000);
$(document).ready(function(){
  $(".tabcontent").hide();
  $(".tabcontent:eq(0)").show()

  $('.tab-title').click(function(){
    $('.tab-title').hasClass('active-tab');
    $('.tab-title').removeClass('active-tab');
    $('.tab-title').next().removeClass('active');
    $(this).addClass('active-tab');
    $(this).next().addClass('active');
    $(".tabcontent").hide();
    $(this).next().show();
  });
});

// Collection discount price
setTimeout(function(){
	$('.discountedprice').each(function() {
		var pr = jQuery(this).text().replace(/[^0-9]/gi, ''); 
		pr = Number(pr);
		pr = (pr/100).toFixed(2);
		$(this).text('R '  + pr);
	});
  
  $('.discount-sale').hide();				 //....Sale tag condition for discount applied....
  if ($(".price--listing .price__unit").children().find(".discountedprice")) {
    $(".price--listing .discountedprice").parentsUntil(".grid-view-item").siblings().find('.discount-sale').show();
    $('.discount-sale .pr-tags').text('SALE');
  }
}, 1500);

// Product page discount price
// setTimeout(function(){
//   var sb = $('.discountedpricepp').text().replace(/[^0-9]/gi, '');
//   sb = Number(sb);
//   sb = (sb/100).toFixed(2);
//   $('.discountedpricepp').text('R '  + sb); 
//   // Add the “Qualifies for free shipping” statement if the product price and discount price >=449.00
//   var beforeprice = $("span.price-item.price-item--regular.gsproductpriceValidated").text();
//   var beforeprices = beforeprice.replace('R ','');
//   if(sb >= 449.00){
//   $(".product__text").show();
//   }
//   else if(beforeprices >= 449.00 && sb == 0.00){
//   $(".product__text").show();
//   }
//   else{
//    $(".product__text").hide();
//   }
//   //$('.discountedpricepp').appendTo( $('.jj-pr-price .price__regular') );
//   $('.discount-sale-pr').hide();
//   if ($('.discountedpricepp').length > 0) { 
//   	//$('.discount-sale').insertBefore( $('.template-product .product-featured-media') );
//     $('.discount-sale-pr').show();
//     $('.discount-sale-pr .pr-tags').text('SALE');
//   }
// }, 2000);

$(document).ready(function(){
    let productprice = $('.price-item.price-item--sale').text();
    let productpriceWithoutR = productprice.replace('R ', '');
    productpriceWithoutR = Number(productpriceWithoutR);
    let productprice2 = $('.price-item.price-item--regular').text();
    let productpriceWithoutR2 = productprice2.replace('R ', '');
    productpriceWithoutR2 = Number(productpriceWithoutR2);
    if (productpriceWithoutR >= 499.00 || productpriceWithoutR2 >= 499.00 ) {
      $(".product__text").show();
    }
    console.log(typeof productpriceWithoutR2);
    console.log(productpriceWithoutR2);
});

//Cart page dicount price
setTimeout(function(){
  //$('.gsdiscounttotal').each(function() {
    var cp = $('.gsdiscounttotal').text().replace(/[^0-9]/gi, ''); 
    cp = Number(cp);
    cp = (cp/100).toFixed(2);
    $('.gsdiscounttotal').text('Discount:- R '  + cp);
  //});
}, 5000);

//
setTimeout(function(){
  $(".product-form__controls-group .selector-wrapper").show();
}, 1000);

// 
$('.product-tooltip-main .tooltip-title').hover(function(){
     $('.product-tooltip-main .tooltip-text').fadeToggle(); 
  });

//sale
$(document).ready(function(){
   $('.discount-custom').siblings('.price__regular').css('text-decoration','line-through');
})

// product page thumbnail slider
$('.product-single__thumbnails').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  // autoplay: true,
  // autoplaySpeed: 2000,
});

//predictive search

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);


setTimeout(() => {
  var priceItems = document.querySelectorAll(".price-item--sale");

  priceItems.forEach(function (element) {
    var priceText = element.textContent.trim();
    var modifiedText = priceText.replace("R ", "R");
    element.textContent = modifiedText;
  });
}, 500);

